/* --------------------------------------------------------------------------------------
   login.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const loginComponent = {
  template: require('./login.html'),
  controller: 'loginCtrl',
  controllerAs: 'vm',
  bindings: {
    back: '&',
    refresh: '<'
  }
}

export class loginCtrl {
  /*@ngInject*/
  constructor(commonService, appService, dataService, userService, $state, $scope) {
    this.commonService = commonService
    this.appService = appService
    this.dataService = dataService
    this.userService = userService
    this.$state = $state
    this.$scope = $scope
  }
  $onInit() {
    this.commonService.setDefaultBackground()
    this.setKeypad()
    this.working = false;
    this.deletealert = false;
    this.deleteduser = false;
  }
  $onChanges() {
    this.user = this.appService.getSelectedUserFromLoginList()
  }
  submit() {

    let enteredPin = $("#loginpin").getkeyboard().$preview.val()

    if (enteredPin != this.user.pin) {
      this.error = "LOGIN_INCORRECT_PIN"
      this.user = this.userService.updateUserInvalidRetry(this.user)
      if (this.user.attempts > 3) {
        this.deleteduser = true
      }
      $("#loginpin").val("")
    } else {
      this.working = true
      this.dataService.setUserAuthData(this.user.accesstoken64, this.user.refreshtoken64)
        .then(result => this.dataService.initializeStandardHeaders(result))
        .then(result => {
          this.error = ""
          this.user.accesstoken64 = result.access_token_64
          this.user.refreshtoken64 = result.refresh_token_64
          this.userService.resetUser(this.user)
          $("#loginpin").getkeyboard().destroy();
          this.$state.go('main')
        })
        .catch(error => {
          this.appService.handleError(error)
            .then(result => {this.exception = result})
        })
        .finally(() => {
          this.working = false
        })
    }
  }
  exceptionClosed() {
    if (this.exception.unauthorized) {
      this.userService.deleteUser(this.user)
      this.user = null
    }
    this.$state.reload()
  }
  deletedUserOk() {
    this.deleteduser = false
    this.userService.deleteUser(this.user)
    this.$state.reload()
  }
  setKeypad() {
    $('#loginpin').xrxkeyboard({
      initialPlaceholder: "",
      layout: 'xrxNum',
      maxLength: 8,
      theme: 'blue',
      appendLocally: false,
      appendTo: '#pinpad',
      alwaysOpen: true,
      backgroundSlide: false,
      beforeVisible: (event, keyboard, el) => {
        $(".xrx-keyboard").css("position", "relative");
        $(".xrx-num-accept").css("visibility", "hidden");
        $(".xrx-num-cancel").css("visibility", "hidden");
        $(".xrx-keyboard").css("box-shadow", "none");
        $(".xrx-keyboard").css("border-top", "none");
        $(".xrx-keyboard").css("transition", "width 0s");
        $(".xrx-keyboard").css("padding-top", "0");
        $(".xrx-keyboard").css("padding-bottom", "0");
      },
      change: (event, keyboard, el) => this.removeError()
    });
  }
  removeError() {
    this.error = null
    this.$scope.$apply()
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/login.component.js